// extracted by mini-css-extract-plugin
module.exports = {"BI":"DocumentPage_BI__w3G9u","ButtonWerender":"DocumentPage_ButtonWerender__14m5M","LineHeight15":"DocumentPage_LineHeight15__27GUF","Subtitle":"DocumentPage_Subtitle__1iktq"};